import React, { Component } from 'react';
import { NumberOfResults } from 'app/area/codetable/list/search';
import { SpinLoader } from 'app/components';
import {
  ConsequencesCodetableListItems
} from 'app/area/codetable/list/list-renderer/screens/consequences/consequences-codetable-list-items';
import { CustomCodetableListComponentProps } from 'app/area/codetable/list/list-renderer/types';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { addLinkFactory } from 'app/area/codetable/list/list-renderer/common/add-link-factory';
import { MergeCodeContainer } from 'app/area/codetable/common/merge-code/merge-code-container';
import styles from './consequences-codetable-list-component.scss';

export class ConsequencesCodetableListComponent extends Component<CustomCodetableListComponentProps> {

  public render() {
    const { itemAccess, fetchingItemAccess, translation, isHierarchy, isHierarchyMode,
      shouldRenderSpinLoader, screenPayload, rootBranch, breadcrumbs,
      codetableId, codeId, codeListBranch, codeListBranchState,
      metadata, mergeCode, updateMergeCode, options, loadOptions, validation, updateValidation, resetValidation,
      loadFromParent, reloadCodeItems, expandCodeItem, deleteCodeItem, loadCodesAccess, clearCodesAccess } = this.props;

    const shouldRenderList = !!codeListBranch && codeListBranch.length > 0 && rootBranch
      && rootBranch.numberOfResults > 0;

    return <SearchFilters {...this.props}>
      <div className={`${styles.codetableListContainer} ${styles.codetableListCenter}`}>
        <div className={styles.codetableListHolder}>
          <div className={styles.numberOfResults}>
            <NumberOfResults
              rootBranch={rootBranch}
              translation={translation} />
          </div>

          {shouldRenderSpinLoader ? <SpinLoader /> : undefined}
          {
            shouldRenderList && <div className={`${styles.listItemsContainer} ${isHierarchyMode ? styles.hierarchyResults : ''}`}>

              <div className={styles.listItems}>
                <ConsequencesCodetableListItems
                  screenPayload={screenPayload}
                  breadcrumbs={breadcrumbs}
                  treeDepthLevel={0}
                  hierarchyMetadata={[]}
                  isZebra={undefined}
                  codetableId={codetableId}
                  codeId={codeId}
                  isHierarchyMode={isHierarchyMode}
                  isHierarchy={isHierarchy}
                  codeAccessConfiguration={this.props.codeAccessConfiguration}
                  codeListBranchState={codeListBranchState}
                  codeListBranch={codeListBranch}
                  loadFromParent={loadFromParent}
                  reloadCodeItems={reloadCodeItems}
                  expandCodeItem={expandCodeItem}
                  deleteCodeItem={deleteCodeItem}
                  itemAccess={itemAccess}
                  fetchingItemAccess={fetchingItemAccess}
                  loadCodesAccess={loadCodesAccess}
                  clearCodesAccess={clearCodesAccess}
                  parentId={undefined}
                  translation={translation}
                  addLinkFactory={addLinkFactory}
                  validation={validation}
                  updateValidation={updateValidation}
                  resetValidation={resetValidation}
                  metadata={metadata}
                  mergeCode={mergeCode}
                  updateMergeCode={updateMergeCode}
                  options={options}
                  loadOptions={loadOptions} />
              </div>
            </div>
          }
        </div>
      </div>
      <MergeCodeContainer {...this.props} />
    </SearchFilters>;
  }
}
